import { useEffect } from 'react';
import { DataTableKey } from 'utils/hooks/useDataTableColumnConfigurations/ColumnConfiguration.types';
import { DataTableTypes } from '@utmost.co/utmost-design-system';
import { usePrevious, useDeepCompare } from '@beeline.com/bp-design-system';
import { useMixpanel } from '../useMixpanel';
import { MixpanelEvents } from '../Events/MixpanelEvents';

export type DataTableQuery = DataTableTypes.OnVariablesChanged<Record<string, unknown>, string> | null | undefined;

export const useDataTableFiltersEvent = <T extends DeepPartial<DataTableQuery>>(
  filters: T | null | undefined,
  dataTableKey: DataTableKey
): void => {
  const { track } = useMixpanel();

  const previousFilters = usePrevious(filters);
  // check if filters where initialized to prevent mixpanel event for the first table load
  const filtersHasChanged = useDeepCompare(filters) && !!previousFilters?.page;

  useEffect(() => {
    if (filtersHasChanged && filters?.page) {
      const { page, sort, query } = filters;
      const renamedQuery = Object.fromEntries(
        Object.entries(query ?? {}).map(([key, value]) => [`filter_${key}`, value])
      );
      const flattenData = {
        ...renamedQuery,
        page_offset: page?.offset,
        page_limit: page?.limit,
        sort_name: sort?.[0]?.type,
        sort_reversed: sort?.[0]?.reversed,
        dataTableKey
      };

      track(MixpanelEvents.dataTableFilters.FILTERS_CHANGED, flattenData);
    }
  }, [dataTableKey, filters, filtersHasChanged, track]);
};
